<template>
  <div>
    <vs-row>
      <vs-col vs-sm="12" vs-md="6" vs-lg="6">
        <div class="bg-white rounded shadow p-4 h-full mx-2">
          <apexchart
            height="350"
            :options="dataTotalStatus.options"
            :series="dataTotalStatus.series"
            :key="dataTotalStatus.key"
            class="w-full">
          </apexchart>
        </div>
      </vs-col>

      <vs-col vs-sm="12" vs-md="6" vs-lg="6">
        <div class="bg-white rounded shadow p-4 h-full mx-2">
          <apexchart
            height="350"
            :options="dataVendorsRequest.options"
            :series="dataVendorsRequest.series"
            :key="dataVendorsRequest.key"
            class="w-full">
          </apexchart>
        </div>
      </vs-col>
    </vs-row>

    <vs-row class="mt-4">
      <vs-col vs-sm="12" vs-md="12" vs-lg="12">
        <div class="bg-white rounded shadow p-4 mx-2">
          <apexchart
            height="350"
            :options="dataRequestMonth.options"
            :series="dataRequestMonth.series"
            :key="dataRequestMonth.key"
            class="w-full">
          </apexchart>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useDashboard } from '../composables/use-dashboard'
import { useNotifier } from '@/composables/useNotifier'
import VueApexCharts from 'vue-apexcharts'

const { notify } = useNotifier()
const dashboard = useDashboard()
const apexchart = VueApexCharts

// Pie chart seguro con leyenda abajo
const dataTotalStatus = ref({
  key: '',
  series: [0],
  options: reactive({
    chart: { type: 'pie', height: 350 },
    labels: ['Sin datos'],
    legend: { position: 'bottom' },
    colors: []
  })
})

// Pie chart seguro sin leyenda
const dataVendorsRequest = ref({
  key: '',
  series: [0],
  options: reactive({
    chart: { type: 'pie', height: 350 },
    labels: ['Sin datos'],
    legend: { show: false },
    colors: []
  })
})

// Bar chart seguro
const dataRequestMonth = ref({
  key: '',
  series: [{ name: 'Request', data: [0] }],
  options: reactive({
    chart: { type: 'bar', height: 350 },
    plotOptions: { bar: { horizontal: false, columnWidth: '50%' } },
    xaxis: { categories: ['Sin datos'] },
    legend: { show: false },
    colors: []
  })
})

// Métodos con conversión segura
const getStatusTotal = async () => {
  const result = await dashboard.getDashboardStatus()
  if (!result.success) {
    notify({ title: 'error', text: 'message_error', color: 'danger' })
    return
  }
  dataTotalStatus.value.key = Date.now()
  dataTotalStatus.value.series = result.response.map(item => Number(item.total) || 0)
  dataTotalStatus.value.options.labels = result.response.map(item => item.name || 'N/A')
  dataTotalStatus.value.options.colors = [
    '#999999', '#007bff', '#dc3545', '#ffc107', '#28a745'
  ]
}

const getVendorRequest = async () => {
  const result = await dashboard.getDashboardVendorRequest()
  if (!result.success) {
    notify({ title: 'error', text: 'message_error', color: 'danger' })
    return
  }
  dataVendorsRequest.value.key = Date.now()
  dataVendorsRequest.value.series = result.response.map(item => Number(item.total) || 0)
  dataVendorsRequest.value.options.labels = result.response.map(item => item.name || 'N/A')
}

const getRequestByMonth = async () => {
  const result = await dashboard.getDashboardRequestMonth()
  if (!result.success) {
    notify({ title: 'error', text: 'message_error', color: 'danger' })
    return
  }
  dataRequestMonth.value.key = Date.now()
  dataRequestMonth.value.series = [{
    name: 'Request',
    data: result.response.map(item => Number(item.total) || 0)
  }]
  dataRequestMonth.value.options.xaxis.categories = result.response.map(item => item.month || 'N/A')
}

onMounted(() => {
  getStatusTotal()
  getRequestByMonth()
  getVendorRequest()
})
</script>
